module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/design-studio-4650129a7c008442c0d7be7e7e53558c.png";